import React, { useState } from "react";
import "./index.css";

// Libraries
import { useNavigate } from "react-router-dom";

// Components
import FindRooms from "../FindRooms";

// Firebase
import { collection, addDoc } from "firebase/firestore";
import db from "../../firebase/firebase";

const CreateRoom = () => {
  const url = "https://justchatio.web.app/";
  const navigate = useNavigate();

  const [roomID, setRoomID] = useState("");
  const [roomName, setRoomName] = useState("");
  const [nickname, setNickname] = useState("");
  const [isCreating, setIsCreating] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);

  const createRoom = async () => {
    if (nickname.trim() === "") {
      alert("Please enter your nickname");
      return;
    }

    setIsCreating(true);
    try {
      const collectionRef = collection(db, "rooms");
      const docRef = await addDoc(collectionRef, {
        roomName: roomName === "" ? "Room" : roomName,
        users: [],
        messages: [],
        isTyping: [],
        isPrivate: isPrivate,
        createdAt: new Date(),
      });

      setRoomID(docRef.id);

      console.log("New room created:", docRef.id);
    } catch (error) {
      console.error("Error creating room:", error);
      setIsCreating(false);
    }
  };

  const joinRoom = () => {
    navigate(`/${roomID}`, { state: { nickname: nickname.trim() } });
  };

  function copyToClipboard(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);

    alert("Copied Link");
  }

  return (
    <div className="container">
      <div className="header-container">
        <h2 className="title" style={{ marginBottom: "0px" }}>
          Just Chat
        </h2>
        <p className="subtitle">
          Simplest chat app ever. Made by{" "}
          <a
            href="https://www.youtube.com/watch?v=dQw4w9WgXcQ&list=RDdQw4w9WgXcQ&start_radio=1"
            target="_blank"
            rel="noreferrer"
          >
            Warren Lee
          </a>
          .
        </p>
      </div>
      <input
        className="input-field"
        type="text"
        value={roomName}
        onChange={(e) => setRoomName(e.target.value)}
        placeholder="Room Name"
        disabled={isCreating}
      />
      <input
        className="input-field"
        type="text"
        value={nickname}
        onChange={(e) => setNickname(e.target.value)}
        placeholder="Your Nickname"
        maxLength={20}
        disabled={isCreating}
      />
      <label style={{ display: "block", marginBottom: "10px" }}>
        <input
          type="checkbox"
          checked={isPrivate}
          onChange={(e) => setIsPrivate(e.target.checked)}
          disabled={isCreating}
        />
        {" "}Private Room (not listed in Public Rooms)
      </label>
      <button className="button" onClick={createRoom} disabled={isCreating}>
        {isCreating ? "Creating..." : "Create Room"}
      </button>
      <div className="link-info">
        <p className="link-info-title">Copy this link and send it to friends:</p>
        {roomID === "" ? (
          <input className="input-field" disabled />
        ) : (
          <div
            className="input-field link"
            onClick={() => copyToClipboard(`${url}${roomID}`)}
          >{`${url}${roomID}`}</div>
        )}
      </div>
      <button className="button" onClick={joinRoom} disabled={roomID === ""}>
        Start Chat
      </button>
      <FindRooms />
    </div>
  );
};

export default CreateRoom;
